import { Helmet } from "react-helmet-async";

const SITE = process.env.REACT_APP_SITE_URL;
const NAME = "PillarWealth";
export const BRAND_TITLE = "PillarWealth.io | Retirement Tracker & TSP Scenario Engine";

export function Seo({ title, description, path = "", type = "website", jsonLd, noindex }) {
  const url = `${SITE}${path}`;
  const full = title ? `${title} | PillarWealth.io` : BRAND_TITLE;
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex" />}
      <meta property="og:site_name" content={NAME} />
      <meta property="og:title" content={full} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="og:image" content={`${SITE}/pillarwealth-logo-512.png`} />
      <meta name="twitter:title" content={full} />
      {description && <meta name="twitter:description" content={description} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const articleJsonLd = (a, path) => ({
  "@context": "https://schema.org",
  "@type": a.category === "Daily TSP Market Recap" ? "NewsArticle" : "BlogPosting",
  headline: a.title,
  description: a.meta_description || a.excerpt,
  datePublished: a.published_date,
  dateModified: a.published_date,
  keywords: (a.tags || []).join(", "),
  articleSection: a.category,
  mainEntityOfPage: `${SITE}${path}`,
  author: { "@type": "Organization", name: NAME },
  publisher: { "@type": "Organization", name: NAME, url: SITE, logo: { "@type": "ImageObject", url: `${SITE}/pillarwealth-logo-512.png` } },
});
